<script>
import con from '@services/connection'
import { servicos, pagarme, adicionarTransacao } from '@constants/URL'
import Title from '@components/section-title'
import Vue from 'vue'
import store from '@state/store'
import { MODAL } from '@constants/Text'
import { possivelJSON, dataWirecard, removeAccents } from '@utils/Format'
import rules from '@constants/Rules'
import { masks } from '@constants/Masks'
import cep from '@services/cep'
import { VMoney } from 'v-money'
import { mask } from 'vue-the-mask'

import { getAreaCode, getPhoneNumber } from '@utils/Find'
import { copyToClipboard } from '@utils/Clipboard'
import CardDiv from '@components/card-div.vue'

export default {
  components: {
    Title,
    CardDiv,
  },
  directives: {
    mask,
    money: VMoney,
  },
  props: {
    bus: {
      default: null,
      type: Object,
    },
  },
  data() {
    return {
      loadingWirecard: false,
      loadingIndicacao: false,
      servico: {},
      mask: masks,
      maskCPF: '###.###.###-##',
      maskCNPJ: '##.###.###/####-##',
      busModal: new Vue(),
      rules: rules,
      steps: 1,
      conta_wirecard: false,
      loading: false,
      loadingDadosPessoais: false,
      pj: false,
      dados_pessoais: {
        firstname: '',
        lastname: '',
        email: '',
        telefone: '',
        cpf: '',
        data_nascimento: '',
        cep: '',
        rua: '',
        numero: '',
        complemento: '',
        bairro: '',
        cidade: '',
        estado: '',
      },
      dados_empresariais: {
        nome_fantasia: '',
        razao_social: '',
        cnpj: '',
        telefone: '',
        rua: '',
        numero: '',
        bairro: '',
        cep: '',
        complemento: '',
        cidade: '',
        estado: '',
      },
      dados_bancarios: {
        codigo: '',
        agencia: '',
        conta: '',
        documento: '',
        nome: '',
      },
      outro_nome: '',
      outro_codigo: '',
      bancos: [],
      validDadosPessoais: false,
      validDadosEmpresariais: false,
      validDadosBancarios: false,
      link_indicacao: '',
    }
  },
  computed: {
    usuarioAtual() {
      return store.getters['user/currentUser'] || {}
    },
  },
  created() {
    this.bus.$on(MODAL.INDICACAO, this.open)
  },
  beforeDestroy() {
    this.bus.$off(MODAL.INDICACAO, this.open)
  },
  methods: {
    open(servico) {
      console.log('SERVICO INDICAÇÂO', servico)
      this.loading = true
      this.servico = servico
      this.collectLinkIndicacao()
      this.busModal.$emit('dialog', !!servico)
    },
    async collectLinkIndicacao(nextStep) {
      if (this.loadingIndicacao) {
        return
      }
      this.loadingIndicacao = true
      let url = `${servicos.link_indicacao}/${this.servico.id_servico}`
      const res = await con.get(url)
      if (res && res.status === 200) {
        this.link_indicacao = possivelJSON(res.value.url_link)
        // this.$showSnack({
        //   text: res.message,
        //   button: true,
        // })
        if (nextStep) {
          this.steps = 2
          this.loadingWirecard = false
          this.loadingIndicacao = false
          this.loading = false
          return
        }
      }
      this.conta_wirecard = res.status !== 404 && res.status !== 401
      this.loadingIndicacao = false
      this.loading = false

      if (!this.conta_wirecard) {
        this.loadBanks()
      }
    },
    async cadastrarWirecard() {
      if (this.loading && this.loadingWirecard) {
        return
      }

      this.loadingWirecard = true
      this.$refs.formDadosPessoais.validate()
      if (this.pj) {
        this.$refs.formDadosEmpresariais.validate()
      }

      let valido = this.pj
        ? this.validDadosPessoais && this.validDadosEmpresariais
        : this.validDadosPessoais

      if (!valido) {
        this.loadingWirecard = false
        return
      }

      const res = await this.salvarDadosPessoais()
      if (res.status === 200) {
        this.collectLinkIndicacao(true)
      } else {
        this.$showSnack({
          text: res.message,
          button: true,
        })
        this.loadingWirecard = false
      }
      this.loading = false
    },
    async salvarDadosPessoais() {
      let data = {
        email: this.dados_pessoais.email,
        number_doc: this.dados_pessoais.cpf,
        name: this.dados_pessoais.firstname,
        lastname: this.dados_pessoais.lastname,
        tipo_doc: 'CPF',
        data_nascimento: dataWirecard(this.dados_pessoais.data_nascimento), // Padrao wirecard
        countryCode: '55',
        areaCode: getAreaCode(this.dados_pessoais.telefone),
        telefone: getPhoneNumber(this.dados_pessoais.telefone),
        rua: this.dados_pessoais.rua,
        numero_rua: this.dados_pessoais.numero,
        complemento: this.dados_pessoais.complemento,
        bairro: this.dados_pessoais.bairro,
        cep: this.dados_pessoais.cep,
        cidade: this.dados_pessoais.cidade,
        estado: this.dados_pessoais.estado,
        pais: 'BRA',
      }
      if (this.pj) {
        data = {
          ...data,
          empresa_nome_fantasia: this.dados_empresariais.nome_fantasia,
          empresa_razao_social: this.dados_empresariais.razao_social,
          empresa_tipo_doc: 'CNPJ',
          empresa_numero_doc: this.dados_empresariais.cnpj,
          empresa_codigo_area: getAreaCode(this.dados_empresariais.telefone),
          empresa_telefone_numero: getPhoneNumber(
            this.dados_empresariais.telefone
          ),
          empresa_rua: this.dados_empresariais.rua,
          empresa_numero: this.dados_empresariais.numero,
          empresa_endereco_complemento: this.dados_empresariais.complemento,
          empresa_bairro: this.dados_empresariais.bairro,
          empresa_cep: this.dados_empresariais.cep,
          empresa_cidade: this.dados_empresariais.cidade,
          empresa_estado: this.dados_empresariais.estado,
          empresa_pais: 'BRA',
        }
      }

      const bank_account = this.collectBankAccount()
      const r = await con.post(pagarme.add_bank_account, bank_account)
      if (r.status !== 200) {
        return new Promise((resolve) => {
          resolve(r)
        })
      }

      // return con.post(cadastroServico.add_wirecard, data) // dev.espelho
      return con.post(pagarme.add_receiver, data)
    },
    async loadBanks() {
      const data = {
        somente_disponiveis: 0,
      }
      let r = await con.get(adicionarTransacao.bancos.listar, data)

      if (typeof r === 'string') {
        r = JSON.parse(r.split('NaN').join('0'))
      }

      if (r.status === 200) {
        this.bancos = r.value.sort((a, b) => {
          return a.nome > b.nome ? 1 : -1
        })
      } else {
        this.bancos = []
      }
    },
    collectBankAccount() {
      if (this.$refs.formDadosBancarios) {
        if (this.$refs.formDadosBancarios.validate()) {
          const banco = this.bancos.find((b) => {
            return b.codigo === this.dados_bancarios.codigo
          })

          const ehOutros = this.dados_bancarios.codigo === -1

          const data = {
            banco: ehOutros
              ? `${this.outro_codigo} - ${this.outro_nome}`
              : `${banco.codigo || ''} - ${banco.nome}`, // cod + nome
            cod_banco: ehOutros
              ? this.outro_codigo
              : this.dados_bancarios.codigo,
            nome_banco: ehOutros ? this.outro_nome : banco.nome,
            agencia: this.dados_bancarios.agencia.split('-')[0] || null,
            conta: this.dados_bancarios.conta.split('-')[0] || null,
            conta_digito: this.dados_bancarios.conta.split('-')[1] || null,
            numero_banco: ehOutros
              ? this.outro_codigo
              : this.dados_bancarios.codigo,
            nome_legal: this.dados_bancarios.nome,
            cpf_cnpj: this.dados_bancarios.documento,
          }
          if (this.dados_bancarios.agencia.includes('-')) {
            data['agencia_digito'] =
              this.dados_bancarios.agencia.split('-')[1] || null
          }
          return data
        }
      }
      return {}
    },
    filterAutocomplete(item, queryText, itemText) {
      return (
        removeAccents(itemText)
          .toLocaleLowerCase()
          .indexOf(removeAccents(queryText).toLocaleLowerCase()) > -1
      )
    },
    carregarDadosPessoais() {
      this.loadingDadosPessoais = true

      setTimeout(() => {
        this.dados_pessoais = {
          ...this.dados_pessoais,
          firstname: this.usuarioAtual.nome.split(' ')[0],
          lastname:
            this.usuarioAtual.nome.split(' ').length > 1
              ? this.usuarioAtual.nome.split(' ').reverse()[0]
              : '',
          email: (this.usuarioAtual.email || '').toLowerCase() || '',
          telefone: this.usuarioAtual.telefone || '',
          cpf: this.usuarioAtual.cpf || '',
          data_nascimento: this.usuarioAtual.data_nascimento || '',
        }
        this.loadingDadosPessoais = false
      }, 500)
    },
    async getCepDadosPessoais() {
      const r = await cep(this.dados_pessoais.cep)
      if (r.status === 200) {
        this.dados_pessoais = {
          ...this.dados_pessoais,
          rua: r.value.logradouro,
          bairro: r.value.bairro,
          cidade: r.value.localidade,
          estado: r.value.uf,
        }
      }
    },
    async getCepDadosEmpresariais() {
      const r = await cep(this.dados_empresariais.cep)
      if (r.status === 200) {
        this.dados_empresariais = {
          ...this.dados_empresariais,
          rua: r.value.logradouro,
          bairro: r.value.bairro,
          cidade: r.value.localidade,
          estado: r.value.uf,
        }
      }
    },
    copyClipboard(input) {
      copyToClipboard(this.$refs[input].$refs.input, this)
    },
  },
}
</script>

<template>
  <BaseModal :bus="busModal" max-width="900px">
    <Title title="Indique o seu serviço" />

    <div
      v-if="loading"
      justify="center"
      align="center"
      class="text-center ma-12 w-100"
    >
      <v-progress-circular
        :size="50"
        color="primary"
        indeterminate
      ></v-progress-circular>
    </div>

    <div v-if="!loading && !conta_wirecard">
      <v-stepper v-model="steps" class="elevation-0" style="100%">
        <v-stepper-header class="elevation-0">
          <v-stepper-step step="1"> Cadastrar recebimento </v-stepper-step>
          <v-divider />
          <v-stepper-step step="2"> Indicar serviço </v-stepper-step>
        </v-stepper-header>

        <v-stepper-content :step="1" class="pt-0 pb-0">
          <div>
            <v-checkbox
              v-model="pj"
              label="Pessoa jurídica"
              class="pl-2 mt-0 pt-2"
              dense
            ></v-checkbox>
            <h1 class="subhead">
              {{ pj ? 'Dados do representante' : 'Dados pessoais' }}
              <v-btn
                small
                class="ml-2"
                :loading="loadingDadosPessoais"
                @click="carregarDadosPessoais"
              >
                Carregar dados pessoais
              </v-btn>
            </h1>
            <CardDiv>
              <v-form
                ref="formDadosPessoais"
                v-model="validDadosPessoais"
                :lazy-validation="true"
              >
                <v-row>
                  <v-text-field
                    v-model="dados_pessoais.firstname"
                    label="Primeiro nome*"
                    class="col-6"
                    :rules="[rules.required]"
                    required
                  ></v-text-field>
                  <v-text-field
                    v-model="dados_pessoais.lastname"
                    :rules="[rules.required]"
                    required
                    label="Último nome*"
                    class="col-6"
                  ></v-text-field>
                  <v-text-field
                    v-model="dados_pessoais.email"
                    :rules="[rules.required, rules.email]"
                    required
                    label="E-mail*"
                    class="col-6"
                  ></v-text-field>
                  <v-text-field
                    v-model="dados_pessoais.telefone"
                    v-mask="[mask.phoneShort, mask.phoneLong]"
                    :rules="[rules.required, rules.phone]"
                    required
                    label="Telefone*"
                    class="col-3"
                  ></v-text-field>
                  <v-text-field
                    v-model="dados_pessoais.cpf"
                    v-mask="mask.cpf"
                    :rules="[rules.required, rules.cpf]"
                    required
                    label="CPF*"
                    class="col-3"
                  ></v-text-field>
                  <v-text-field
                    v-model="dados_pessoais.data_nascimento"
                    v-mask="mask.data"
                    label="Data de nascimento*"
                    class="col-4"
                    :rules="[rules.required, rules.data]"
                  ></v-text-field>
                </v-row>
                <v-divider />
                <v-row>
                  <v-text-field
                    v-model="dados_pessoais.cep"
                    v-mask="mask.cep"
                    label="CEP*"
                    class="col-3"
                    :rules="[rules.required, rules.cep]"
                    required
                    @change="getCepDadosPessoais"
                  ></v-text-field>
                  <v-text-field
                    v-model="dados_pessoais.rua"
                    label="Rua"
                    class="col-6"
                    disabled
                  ></v-text-field>
                  <v-text-field
                    v-model="dados_pessoais.numero"
                    v-mask="mask.number"
                    label="Número*"
                    class="col-3"
                    :rules="[rules.required]"
                    required
                  ></v-text-field>
                  <v-text-field
                    v-model="dados_pessoais.complemento"
                    label="Complemento"
                    class="col-3"
                  ></v-text-field>
                  <v-text-field
                    v-model="dados_pessoais.bairro"
                    label="Bairro"
                    class="col-3"
                    disabled
                  ></v-text-field>
                  <v-text-field
                    v-model="dados_pessoais.cidade"
                    label="Cidade"
                    class="col-3"
                    disabled
                  ></v-text-field>
                  <v-text-field
                    v-model="dados_pessoais.estado"
                    label="Estado"
                    class="col-3"
                    disabled
                  ></v-text-field>
                </v-row>
              </v-form>
            </CardDiv>

            <h1 v-if="pj" class="subhead">Dados da empresa</h1>
            <CardDiv v-if="pj">
              <v-form
                ref="formDadosEmpresariais"
                v-model="validDadosEmpresariais"
                lazy-validation
              >
                <template>
                  <v-row>
                    <v-text-field
                      v-model="dados_empresariais.nome_fantasia"
                      label="Nome fantasia*"
                      class="col-6"
                      :rules="[rules.required]"
                      required
                    ></v-text-field>
                    <v-text-field
                      v-model="dados_empresariais.razao_social"
                      label="Razão social*"
                      class="col-6"
                      :rules="[rules.required]"
                      required
                    ></v-text-field>
                    <v-text-field
                      v-model="dados_empresariais.telefone"
                      v-mask="[mask.phoneShort, mask.phoneLong]"
                      :rules="[rules.required, rules.phone]"
                      required
                      label="Telefone*"
                      class="col-6"
                    ></v-text-field>
                    <v-text-field
                      v-model="dados_empresariais.cnpj"
                      v-mask="mask.cnpj"
                      :rules="[rules.required, rules.cnpj]"
                      required
                      label="CNPJ*"
                      class="col-6"
                    ></v-text-field>
                  </v-row>
                  <v-divider />
                  <v-row>
                    <v-text-field
                      v-model="dados_empresariais.cep"
                      v-mask="mask.cep"
                      :rules="[rules.required, rules.cep]"
                      required
                      label="CEP*"
                      class="col-3"
                      @change="getCepDadosEmpresariais"
                    ></v-text-field>
                    <v-text-field
                      v-model="dados_empresariais.rua"
                      label="Rua"
                      class="col-6"
                      disabled
                    ></v-text-field>
                    <v-text-field
                      v-model="dados_empresariais.numero"
                      v-mask="mask.number"
                      label="Número*"
                      class="col-3"
                      :rules="[rules.required]"
                      required
                    ></v-text-field>
                    <v-text-field
                      v-model="dados_empresariais.complemento"
                      label="Complemento"
                      class="col-3"
                    ></v-text-field>
                    <v-text-field
                      v-model="dados_empresariais.bairro"
                      label="Bairro"
                      class="col-3"
                      disabled
                    ></v-text-field>
                    <v-text-field
                      v-model="dados_empresariais.cidade"
                      label="Cidade"
                      class="col-3"
                      disabled
                    ></v-text-field>
                    <v-text-field
                      v-model="dados_empresariais.estado"
                      label="Estado"
                      class="col-3"
                      disabled
                    ></v-text-field>
                  </v-row>
                </template>
              </v-form>
            </CardDiv>

            <h1 class="subhead mt-10">Dados bancários</h1>
            <CardDiv>
              <v-form
                ref="formDadosBancarios"
                v-model="validDadosBancarios"
                lazy-validation
              >
                <v-row>
                  <v-text-field
                    v-model="dados_bancarios.nome"
                    label="Nome do titular*"
                    class="col-7"
                    :rules="[rules.required]"
                  />
                  <v-text-field
                    v-model="dados_bancarios.documento"
                    v-mask="[maskCPF, maskCNPJ]"
                    label="Documento do titular (CPF ou CNPJ)*"
                    class="col-5"
                    :rules="[rules.required, rules.cpf_cnpj]"
                  />
                  <v-autocomplete
                    v-model="dados_bancarios.codigo"
                    label="Banco*"
                    class="col-7"
                    :items="bancos"
                    :item-text="
                      (item) => {
                        return `${item.codigo} - ${item.nome}`
                      }
                    "
                    item-value="codigo"
                    clearable
                    :filter="filterAutocomplete"
                    :rules="[rules.required]"
                  >
                  </v-autocomplete>
                  <v-text-field
                    v-model="dados_bancarios.agencia"
                    v-mask="['####', '####-#', '####-##']"
                    label="Agência*"
                    class="col-2"
                    :rules="[rules.required]"
                  ></v-text-field>
                  <v-text-field
                    v-model="dados_bancarios.conta"
                    v-mask="[
                      '###-#',
                      '####-#',
                      '#####-#',
                      '######-#',
                      '#######-#',
                      '########-#',
                      '#########-#',
                    ]"
                    label="Conta*"
                    class="col-3"
                    :rules="[rules.required]"
                  />
                  <v-text-field
                    v-if="dados_bancarios.codigo === -1"
                    v-model="outro_nome"
                    class="col-7"
                    label="Nome do banco*"
                    :rules="[rules.required]"
                  />
                  <v-text-field
                    v-if="dados_bancarios.codigo === -1"
                    v-model.number="outro_codigo"
                    class="col-5"
                    label="Código do banco*"
                    :rules="[rules.required]"
                  />
                </v-row>
              </v-form>
            </CardDiv>
            <small class="text-secondary mt-5">* Campos obrigatórios</small>
          </div>
        </v-stepper-content>

        <v-stepper-content :step="2" class="pt-0 pb-0">
          <div style="margin-bottom: 20px">
            <p>
              Compartilhando esse link você ganha uma porcentagem do valor do
              serviço por indicação.
            </p>
          </div>
          <v-text-field
            ref="linkIndicacao"
            v-model="link_indicacao"
            readonly
            label="Link de indicação do serviço"
          >
            <template v-slot:append>
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn icon v-on="on" @click="copyClipboard('linkIndicacao')">
                    <v-icon>mdi-content-copy</v-icon>
                  </v-btn>
                </template>
                <span>Copiar link</span>
              </v-tooltip>
            </template>
          </v-text-field>
        </v-stepper-content>
      </v-stepper>
    </div>
    <div v-if="!loading && conta_wirecard">
      <div style="margin-bottom: 20px">
        <p>
          Compartilhando esse link você ganha uma porcentagem do valor do
          serviço por indicação.
        </p>
      </div>
      <v-text-field
        ref="linkIndicacao"
        v-model="link_indicacao"
        readonly
        label="Link de indicação do serviço"
      >
        <template v-slot:append>
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn icon v-on="on" @click="copyClipboard('linkIndicacao')">
                <v-icon>mdi-content-copy</v-icon>
              </v-btn>
            </template>
            <span>Copiar link</span>
          </v-tooltip>
        </template>
      </v-text-field>
    </div>

    <template v-slot:actions="{ close }">
      <v-spacer />
      <BaseButton underlined @click="close"> Voltar </BaseButton>
      <BaseButton
        v-if="Number(steps) === 1 && !conta_wirecard"
        primary
        :loading="loadingWirecard"
        @click="cadastrarWirecard"
      >
        Cadastrar conta
      </BaseButton>
      <BaseButton
        v-if="Number(steps) === 2 || conta_wirecard"
        primary
        @click="close"
      >
        Ok
      </BaseButton>
      <v-spacer />
    </template>
  </BaseModal>
</template>


